export default __webpack_public_path__ + "static/media/ten_of_pentacles.dc3e4c96.png";